import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {PrimaryButton} from 'imports/DesignImports';

import {
  CircularProgress,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui';

const styles = {
  continueButton: {
    border: '1px solid #11AB99',
    color: 'white',
    textAlign: 'center',
    borderRadius: '0px',
    backgroundColor: '#11AB99',
    fontFamily: 'lato'
  },
  centerDiv: {
    textAlign: 'center'
  }
}

class Workshop extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: false,
      loading: true,
      selected_projects: [],
    }
  }

  componentDidMount(){
    this.getSelectedProjects();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return (
      <div>
        <h1>Workshop</h1>
        <p>Has completado una etapa muy importante, la identificación del portafolio de innovación:</p>

        <Table selectable={false}>
          <TableHeader displaySelectAll={false}>
            <TableRow>
              <TableHeaderColumn>Nombre</TableHeaderColumn>
              <TableHeaderColumn>Lider</TableHeaderColumn>
              <TableHeaderColumn>Correo Lider</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.state.selected_projects.map((project, i) => {
            return(<TableRow key={i}>
              <TableRowColumn>{project.name}</TableRowColumn>
              <TableRowColumn>{project.leader_first_name+" "+project.leader_last_name}</TableRowColumn>
              <TableRowColumn>{project.leader_email}</TableRowColumn>
            </TableRow>)
            })}
          </TableBody>
        </Table>
        <br />
        <p>Para la próxima etapa es recomendable realizar un workshop junto a los líderes de proyecto para apoyar en el cálculo económico del proyecto y así realizar una correcta ficha de proyecto i3.</p>
        <br />
        <div style={styles.centerDiv}>
          <PrimaryButton label="Continuar a etapa Fichas i3" onClick={()=>{this.goToNextStage()}} href="/portfolio/files" />
        </div>
    </div>
    );
  }

  getSelectedProjects = () => {
    let token = this.props.cookies.get('token');
    let user = this.props.cookies.get('user');
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ token}
    });
    connection.get(routes.selectedProjects(user.company_id))
      .then((response) => {
        this.setState({
          error: false,
          loading: false,
          selected_projects: response.data.projects
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          error: true,
          loading: false
        })
      });
  }

  goToNextStage = () => {
    let token = this.props.cookies.get('token');
    let user = this.props.cookies.get('user');
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ token}
    });
    connection.patch(routes.nextStage(user.company_id))
      .then((response) => {
        this.setState({
          error: false,
          loading: false
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          error: true,
          loading: false
        })
      });
  }

}

export default withCookies(withRouter(Workshop));



// WEBPACK FOOTER //
// ./src/views/selection/WorkshopView.js